/* eslint-disable import/no-cycle */
import { CalculatorParticipantType, ICalculatorRule, ICategoryGroup, TipCalculatorMethod } from './CalculatorRule';
import { IEmployee } from './Employee';
import { IJob } from './Job';
import { IPayout, PayoutMethodTypes, PayoutRefType, PayoutStatus } from './Payout';
import { IBaseSite } from './Site';
import { ITipCalculatorChangeLogEntry, ITipCalculatorResult, ITipCalculatorResultCategory, ITipCalculatorResultContribution, ITipCalculatorResultEmployee, ITipCalculatorResultReceived } from './TipCalculator';
import { ISubmittedBy } from './User';

export enum AcceptancePaymentSetStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

interface IBasePaymentSetStats {
  gross: number;
  holdbacks: number;
  net: number;
  autoGratuities: number;
}

interface IPaymentStatsByType extends IBasePaymentSetStats {
  type: PayoutStatus;
  count: number;
}

export interface IPaymentSet {
  id: string;
  description: string;
  paymentDate: string;
  site: IBaseSite;
  paymentCategory?: string;
  totals: {
    autoGratuities: number;
    gross: number;
    holdbacks: number;
    net: number;
    status: IPaymentStatsByType[];
    participants: IPaymentSetTotalsParticipant[];
  };
  payouts: IPayout[];
  refType?: PayoutRefType;
  refId?: string;
  calculations?: IPaymentSetCalculations;
  changeLog?: ITipCalculatorChangeLogEntry[];
  createdBy: ISubmittedBy;
  createdAt: string;
  updatedAt: string;
}

export interface IPaymentSetTotalsParticipant {
  name: string;
  type: CalculatorParticipantType;
  totals: {
    autoGratuities: number;
    tips: number;
    total: number;
  };
}

export interface ICreatePaymentTotalsPayload {
  allocated: number;
  collected: number;
  cash: number;
  creditCard: number;
  creditCardFee: number;
  points?: number;
}

export interface IPaymentRetainer {
  total: number;
}

export interface IPaymentCalculated {
  points: number;
  total: number;
}

export interface IPaymentCalculatorPools {
  calculated: IPaymentCalculated;
  jobTitle: string;
  minutes: number;
  categories: ITipCalculatorResultCategory[];
  creditCard?: number;
  received: ITipCalculatorResultReceived[];
  retained?: IPaymentRetainer;
  contributions: ITipCalculatorResultContribution[];
  total: number;
}

export interface IPaymentCalculationResult {
  segment: string;
  employees: ITipCalculatorResultEmployee[];
  pools: IPaymentCalculatorPools[];
  rules: ICalculatorRule[];
  totals: ICreatePaymentTotalsPayload;
  categoryGroups: ICategoryGroup[];
  start?: string;
  end?: string;
}

export interface IPaymentSetCalculations {
  method: TipCalculatorMethod;
  results: ITipCalculatorResult[];
}

export interface IPaymentPayout {
  currency?: string;
  employeeId: string;
  gross: number;
  holdback: number;
  job: IJob;
  net: number;
  notes?: string;
  refId?: string;
  refType?: string;
  type?: string;
}

export interface ICreatePaymentPayload {
  paymentDate: string;
  siteId: string;
  workflow: PayoutMethodTypes;
  description?: string;
  paymentCategory?: string;
  refId?: string;
  refType?: string;
  calculations?: IPaymentSetCalculations;
  changeLog?: ITipCalculatorChangeLogEntry[];
  payouts: IPaymentPayout[];
}

export interface IUploadPayment {
  name?: string;
  employeeId?: string;
  amount: number;
  employee?: IEmployee;
  employeeMatch?: IEmployee[];
}
